module.exports = __webpack_public_path__ + "static/zgj-b65683e491f35d7ec932a55ba45c22dc.png";